import type { Middleware } from '@reduxjs/toolkit';
import { isAction } from '@reduxjs/toolkit';

import { isLoggedSelector } from 'entities/user';

import { getPersistedStoreInstance } from '../lib/usePersistedStore';

import type { GlobalState } from './store';

export const persistedStoreMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  const prevState = storeAPI.getState() as GlobalState;
  const isAuthPrev = isLoggedSelector(prevState);

  const dispatchResult = next(action);
  const nextState = storeAPI.getState();
  const isAuthNext = isLoggedSelector(nextState);

  if (!isAction(action)) {
    return dispatchResult;
  }

  const persistedStore = getPersistedStoreInstance();

  if (!persistedStore) {
    return dispatchResult;
  }

  // Пользователь разлогинился
  if (isAuthPrev && !isAuthNext) {
    persistedStore.clear();
    persistedStore.configurePersistedPaths(false);
    return dispatchResult;
  }

  // Пользователь залогинился
  if (!isAuthPrev && isAuthNext) {
    persistedStore.configurePersistedPaths(true);
  }

  persistedStore.save();

  return dispatchResult;
};
